import Vue from 'vue'
import Router from 'vue-router'

import indexRouter from "../views/home/router";
import userRouter from "../views/user/router"
import articleRouter from "../views/article/router"
import gamesRouter from '../views/games/router'
import celebrityGradeRouter from '../views/celebrityGrade/router'

Vue.use(Router)

export default new Router({
    routes: [].concat(indexRouter, userRouter, articleRouter, gamesRouter, celebrityGradeRouter)
})

















// WEBPACK FOOTER //
// ./src/router/index.js